export { default } from './Institutes.component';
